import http from '@/utils/ajax'
import { TARIFF_RATE_INIT_LOADING, TARIFF_RATE_INIT_SUCCESS, TARIFF_RATE_INIT_FAIL, TARIFF_RATE_COMMIT_KEY } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

export const state = {
  // Agency level init (bring in menu for specific modules eg: travel motor etc)
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {},
  tarfRate: {
    tarfRateId: {
      tarfRateMode: null,
      busCls: null,
      tariff: null,
      benefit: null,
      seqNo: null,
      effDate: null,
      fact1: null,
      fact2: null,
      fact3: null,
      fact4: null,
      fact5: null,
      fact6: null
    }
  }
}

const getters = {

}

const mutations = {
  [TARIFF_RATE_INIT_LOADING](state, err) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [TARIFF_RATE_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [TARIFF_RATE_INIT_FAIL](state, err) {
    state.init = 2
    state.initErr = err
    state.menu = {}
  },
  [TARIFF_RATE_COMMIT_KEY](state, data) {
    state.tarfRate.tarfRateId.tarfRateMode = data.tarfRateMode
    state.tarfRate.tarfRateId.busCls = data.busCls
    state.tarfRate.tarfRateId.tariff = data.tariff
    state.tarfRate.tarfRateId.benefit = data.benefit
    state.tarfRate.tarfRateId.seqNo = data.seqNo
    state.tarfRate.tarfRateId.effDate = data.effDate
    state.tarfRate.tarfRateId.fact1 = data.fact1
    state.tarfRate.tarfRateId.fact2 = data.fact2
    state.tarfRate.tarfRateId.fact3 = data.fact3
    state.tarfRate.tarfRateId.fact4 = data.fact4
    state.tarfRate.tarfRateId.fact5 = data.fact5
    state.tarfRate.tarfRateId.fact6 = data.fact6
  }
}

const actions = {
  async tarfRateManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.tarfRateManagementController
    commit(TARIFF_RATE_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(TARIFF_RATE_INIT_SUCCESS, commitResult)
    } catch (err) {
      commit(TARIFF_RATE_INIT_FAIL, extractMessages(err))
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
